module.exports = __webpack_public_path__ + "static/media/skeleton_wizard_hood.80f97f28.png";